import axios, {AxiosResponse} from 'axios'
import qs from 'qs'
import {StarChangesFilters, StarChangesResponse} from './_models'

const API_URL = process.env.REACT_APP_API_URL + '/api'
const STAR_CHANGES_URL = `${API_URL}/reports/star-changes`

const toQuery = ({from, to, only_existing}: StarChangesFilters): string =>
  qs.stringify({from, to, ...(only_existing ? {only_existing: 1} : {})})

const getStarChanges = (filters: StarChangesFilters): Promise<StarChangesResponse> => {
  return axios
    .get(`${STAR_CHANGES_URL}?${toQuery(filters)}`)
    .then((d: AxiosResponse<StarChangesResponse>) => d.data)
}

// Sempre gerado em fila: o backend responde 202 com a mensagem para a área de downloads.
const exportStarChanges = (filters: StarChangesFilters): Promise<{message: string; id: number}> => {
  return axios
    .get(`${STAR_CHANGES_URL}/export?${toQuery(filters)}`)
    .then((d: AxiosResponse<{message: string; id: number}>) => d.data)
}

export {getStarChanges, exportStarChanges}
